// extracted by mini-css-extract-plugin
export default {"container":"game_container__LZMKz","hand_container":"game_hand_container__2nwql","results_container":"game_results_container__2ue4l"};